/* eslint-disable @typescript-eslint/prefer-nullish-coalescing */
import { SDK_NAME, SDK_VERSION } from '../constants';
export var InjectQueryPlugin = function (client) {
    client.on('start', function () {
        var _a = client.config(), deviceId = _a.deviceId, sessionId = _a.sessionId, release = _a.release, env = _a.env, offset = _a.offset;
        var query = {
            did: deviceId,
            sid: sessionId,
            release: release,
            env: env,
            sname: SDK_NAME,
            sversion: SDK_VERSION,
            soffset: offset || 0,
        };
        var queryString = '';
        for (var k in query) {
            queryString += "&" + k + "=" + query[k];
        }
        var sender = client.getSender();
        sender.setEndpoint(sender.getEndpoint() + queryString.replace('&', '?'));
    });
};
//# sourceMappingURL=inject-query.js.map